export default "__VITE_ASSET__B91cHB3x__"